module.exports = __webpack_public_path__ + "static/img/banner_small_1027.0dd7fde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/banner_small_1027.png
// module id = 0Dms
// module chunks = 0